// extracted by mini-css-extract-plugin
module.exports = {"switcher":"currency-switcher_switcher__3v0WF","switcherBtn":"currency-switcher_switcherBtn__2BR2E"};